// extracted by mini-css-extract-plugin
export var social = "style-module--social--b839e";
export var social__list = "style-module--social__list--774cd";
export var social__listItem = "style-module--social__list-item--532dd";
export var social__title = "style-module--social__title--ff35a";